import { Route, RouteObject, useRouteError } from 'react-router-dom'

/**
 * react-router v6 decided to catch now all errors
 * so our top level ErrorBoundary doesn't get those errors and react-router just print error strack trace in app instead of BrokenComponent
 * need to bubble this error from react-router so our custom error boundary can catch
 */
const BubbleError = () => {
    throw useRouteError()
}

export const mapRouteConfigToRouteComponent = (route: RouteObject) => {
    let children = null

    if (route.children) {
        children = route.children.map(mapRouteConfigToRouteComponent)
    }

    if (route.index) {
        return (
            <Route
                key={'index'}
                index
                element={route.element}
                errorElement={<BubbleError />}
            />
        )
    }

    return (
        <Route
            key={route.path}
            path={route.path}
            element={route.element}
            errorElement={<BubbleError />}
        >
            {children}
        </Route>
    )
}
